import { PessoaResumo, PessoaDetalhe, EstadoCadastro, TipoVinculo, EstadoVinculo, Sexo } from '../models';

export const PESSOAS_LISTA_MOCK: PessoaResumo[] = [
  {
    id: '1',
    cpf: '11122233344',
    nomeCompleto: 'João Silva Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v1', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0001', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-01T00:00:00Z'
  },
  {
    id: '2',
    cpf: '55566677788',
    nomeCompleto: 'Maria Souza Civil',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v2', tipo: TipoVinculo.DP, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-01T00:00:00Z'
  },
  {
    id: '3',
    cpf: '33344455566',
    nomeCompleto: 'Antônio Santos Pensionista',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v3', tipo: TipoVinculo.PS, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-01T00:00:00Z'
  },
  {
    id: '4',
    cpf: '44455566677',
    nomeCompleto: 'Carlos Eduardo Civil',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v4', tipo: TipoVinculo.CV, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-01T00:00:00Z'
  },
  {
    id: '5',
    cpf: '55566677799',
    nomeCompleto: 'Fernanda Lima Terceirizada',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v5', tipo: TipoVinculo.TZ, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-01T00:00:00Z'
  },
  {
    id: '6',
    cpf: '66677788811',
    nomeCompleto: 'Rafael Oliveira Policial',
    nomeSocial: 'Oliveira',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v6', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0006', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-02T00:00:00Z'
  },
  {
    id: '7',
    cpf: '77788899922',
    nomeCompleto: 'Juliana Costa Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v7', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0007', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-03T00:00:00Z'
  },
  {
    id: '8',
    cpf: '88899900033',
    nomeCompleto: 'Lucas Pereira Dependente',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v8', tipo: TipoVinculo.DP, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-04T00:00:00Z'
  },
  {
    id: '9',
    cpf: '99900011144',
    nomeCompleto: 'Beatriz Alencar Pensionista',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v9', tipo: TipoVinculo.PS, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-05T00:00:00Z'
  },
  {
    id: '10',
    cpf: '10111213155',
    nomeCompleto: 'Thiago Martins Civil',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v10', tipo: TipoVinculo.CV, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-06T00:00:00Z'
  },
  {
    id: '11',
    cpf: '12131415166',
    nomeCompleto: 'Aline Rocha Terceirizada',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v11', tipo: TipoVinculo.TZ, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-07T00:00:00Z'
  },
  {
    id: '12',
    cpf: '13141516177',
    nomeCompleto: 'Bruno Lima Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v12', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0012', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-08T00:00:00Z'
  },
  {
    id: '13',
    cpf: '14151617188',
    nomeCompleto: 'Camila Alves Dependente',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v13', tipo: TipoVinculo.DP, estado: EstadoVinculo.EFETIVADO, matriculaPm: '' }],
    criadoEm: '2023-01-09T00:00:00Z'
  },
  {
    id: '14',
    cpf: '15161718199',
    nomeCompleto: 'Diego Silva Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v14', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0014', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-10T00:00:00Z'
  },
  {
    id: '15',
    cpf: '16171819200',
    nomeCompleto: 'Eduardo Santos Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v15', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0015', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-11T00:00:00Z'
  },
  {
    id: '16',
    cpf: '17181920211',
    nomeCompleto: 'Felipe Souza Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v16', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0016', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-12T00:00:00Z'
  },
  {
    id: '17',
    cpf: '18192021222',
    nomeCompleto: 'Gabriel Silva Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v17', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0017', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-13T00:00:00Z'
  },
  {
    id: '18',
    cpf: '19202122233',
    nomeCompleto: 'Heitor Costa Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v18', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0018', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-14T00:00:00Z'
  },
  {
    id: '19',
    cpf: '20212223244',
    nomeCompleto: 'Igor Oliveira Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v19', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0019', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-15T00:00:00Z'
  },
  {
    id: '20',
    cpf: '21222324255',
    nomeCompleto: 'Jessica Santos Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v20', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0020', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-16T00:00:00Z'
  },
  {
    id: '21',
    cpf: '22232425266',
    nomeCompleto: 'Kelly Rocha Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v21', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0021', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-17T00:00:00Z'
  },
  {
    id: '22',
    cpf: '23242526277',
    nomeCompleto: 'Leonardo Martins Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v22', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0022', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-18T00:00:00Z'
  },
  {
    id: '23',
    cpf: '24252627288',
    nomeCompleto: 'Marcelo Silva Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v23', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0023', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-19T00:00:00Z'
  },
  {
    id: '24',
    cpf: '25262728299',
    nomeCompleto: 'Natalia Costa Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v24', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0024', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-20T00:00:00Z'
  },
  {
    id: '25',
    cpf: '26272829300',
    nomeCompleto: 'Otavio Santos Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v25', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0025', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-21T00:00:00Z'
  },
  {
    id: '26',
    cpf: '27282930311',
    nomeCompleto: 'Patricia Souza Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v26', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0026', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-22T00:00:00Z'
  },
  {
    id: '27',
    cpf: '28293031322',
    nomeCompleto: 'Renato Silva Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v27', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0027', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-23T00:00:00Z'
  },
  {
    id: '28',
    cpf: '29303132333',
    nomeCompleto: 'Sabrina Costa Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    vinculos: [{ id: 'v28', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0028', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-24T00:00:00Z'
  },
  {
    id: '29',
    cpf: '30313233344',
    nomeCompleto: 'Valter Oliveira Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v29', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0029', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-25T00:00:00Z'
  },
  {
    id: '30',
    cpf: '31323334355',
    nomeCompleto: 'Yago Santos Policial',
    nomeSocial: '',
    estadoCadastro: EstadoCadastro.VALIDADO,
    vinculos: [{ id: 'v30', tipo: TipoVinculo.PM, matriculaPm: 'PM.2023.0030', estado: EstadoVinculo.EFETIVADO }],
    criadoEm: '2023-01-26T00:00:00Z'
  }
];

export const PESSOA_DETALHES_MOCK_MAP: Record<string, PessoaDetalhe> = {
  '1': {
    id: '1',
    cpf: '11122233344',
    estadoCadastro: EstadoCadastro.VALIDADO,
    dadosCortex: {
      cpf: '11122233344',
      nomeCompleto: 'João Silva Policial',
      nomeMae: 'Ana Silva',
      dataNascimento: '1985-05-15',
      rgNumero: '1234567',
      rgOrgaoExpedidor: 'SSP/DF',
      rgUf: 'DF',
      rgDataEmissao: '2005-01-01',
      sexo: Sexo.M,
      nacionalidade: 'Brasileira',
      naturalidadeUf: 'DF',
      naturalidadeCidade: 'Brasília'
    },
    vinculos: [
      {
        id: 'v1',
        tipo: TipoVinculo.PM,
        matriculaPm: 'PM.2023.0001',
        estado: EstadoVinculo.EFETIVADO,
        postoGraduacaoInicial: 'Tenente-Coronel PM',
        quadroIngresso: 'QOPM'
      } as any
    ],
    enderecos: [],
    telefones: [],
    emails: [],
    formacaoAcademica: [],
    documentos: [],
    biometriaColetada: false,
    criadoEm: '2023-01-01T00:00:00Z',
    criadoPor: 'Sistema',
    atualizadoEm: new Date().toISOString(),
    atualizadoPor: 'Sistema'
  },
  '2': {
    id: '2',
    cpf: '55566677788',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    dadosCortex: {
      cpf: '55566677788',
      nomeCompleto: 'Maria Souza Civil',
      nomeMae: 'Clara Souza',
      dataNascimento: '1990-08-20',
      rgNumero: '7654321',
      rgOrgaoExpedidor: 'SSP/DF',
      rgUf: 'DF',
      rgDataEmissao: '2010-01-01',
      sexo: Sexo.F,
      nacionalidade: 'Brasileira',
      naturalidadeUf: 'DF',
      naturalidadeCidade: 'Brasília'
    },
    vinculos: [
      {
        id: 'v2',
        tipo: TipoVinculo.DP,
        estado: EstadoVinculo.EFETIVADO,
        matriculaPm: '',
        postoGraduacaoInicial: 'Major PM',
        quadroIngresso: 'QPPM'
      } as any
    ],
    enderecos: [],
    telefones: [],
    emails: [],
    formacaoAcademica: [],
    documentos: [
      {
        id: 'doc-ocr-1',
        nomeArquivo: 'certidao-casamento.pdf',
        mimeType: 'application/pdf',
        tamanho: 2048576,
        url: 'http://simulacao.pm.df.gov.br/certidao-casamento.pdf',
        enviadoEm: new Date().toISOString(),
        campo: 'CERTIDAO_CIVIL',
        ocrDivergencias: ['OCR divergente no RG']
      } as any
    ],
    biometriaColetada: false,
    criadoEm: '2023-01-01T00:00:00Z',
    criadoPor: 'Sistema',
    atualizadoEm: new Date().toISOString(),
    atualizadoPor: 'Sistema'
  },
  '3': {
    id: '3',
    cpf: '33344455566',
    estadoCadastro: EstadoCadastro.VALIDADO,
    dadosCortex: {
      cpf: '33344455566',
      nomeCompleto: 'Antônio Santos Pensionista',
      nomeMae: 'Julia Santos',
      dataNascimento: '1955-12-05',
      rgNumero: '9876543',
      rgOrgaoExpedidor: 'SSP/DF',
      rgUf: 'DF',
      rgDataEmissao: '1975-01-01',
      sexo: Sexo.M,
      nacionalidade: 'Brasileira',
      naturalidadeUf: 'DF',
      naturalidadeCidade: 'Brasília'
    },
    vinculos: [
      {
        id: 'v3',
        tipo: TipoVinculo.PS,
        estado: EstadoVinculo.EFETIVADO,
        matriculaPm: '',
        postoGraduacaoInicial: 'Capitão PM',
        quadroIngresso: 'QOPM'
      } as any
    ],
    enderecos: [],
    telefones: [],
    emails: [],
    formacaoAcademica: [],
    documentos: [],
    biometriaColetada: false,
    criadoEm: '2023-01-01T00:00:00Z',
    criadoPor: 'Sistema',
    atualizadoEm: new Date().toISOString(),
    atualizadoPor: 'Sistema'
  },
  '4': {
    id: '4',
    cpf: '44455566677',
    estadoCadastro: EstadoCadastro.DADOS_BASICOS_COLETADOS,
    dadosCortex: {
      cpf: '44455566677',
      nomeCompleto: 'Carlos Eduardo Civil',
      nomeMae: 'Tereza Eduardo',
      dataNascimento: '1988-03-25',
      rgNumero: '2468135',
      rgOrgaoExpedidor: 'SSP/DF',
      rgUf: 'DF',
      rgDataEmissao: '2008-01-01',
      sexo: Sexo.M,
      nacionalidade: 'Brasileira',
      naturalidadeUf: 'DF',
      naturalidadeCidade: 'Brasília'
    },
    vinculos: [
      {
        id: 'v4',
        tipo: TipoVinculo.CV,
        estado: EstadoVinculo.EFETIVADO,
        matriculaPm: '',
        postoGraduacaoInicial: '1º Tenente PM',
        quadroIngresso: 'QPPM'
      } as any
    ],
    enderecos: [],
    telefones: [],
    emails: [],
    formacaoAcademica: [],
    documentos: [],
    biometriaColetada: false,
    criadoEm: '2023-01-01T00:00:00Z',
    criadoPor: 'Sistema',
    atualizadoEm: new Date().toISOString(),
    atualizadoPor: 'Sistema'
  },
  '5': {
    id: '5',
    cpf: '55566677799',
    estadoCadastro: EstadoCadastro.VALIDADO,
    dadosCortex: {
      cpf: '55566677799',
      nomeCompleto: 'Fernanda Lima Terceirizada',
      nomeMae: 'Sandra Lima',
      dataNascimento: '1995-10-10',
      rgNumero: '1357924',
      rgOrgaoExpedidor: 'SSP/DF',
      rgUf: 'DF',
      rgDataEmissao: '2015-01-01',
      sexo: Sexo.F,
      nacionalidade: 'Brasileira',
      naturalidadeUf: 'DF',
      naturalidadeCidade: 'Brasília'
    },
    vinculos: [
      {
        id: 'v5',
        tipo: TipoVinculo.TZ,
        estado: EstadoVinculo.EFETIVADO,
        matriculaPm: '',
        postoGraduacaoInicial: 'Soldado PM',
        quadroIngresso: 'QPPM'
      } as any
    ],
    enderecos: [],
    telefones: [],
    emails: [],
    formacaoAcademica: [],
    documentos: [],
    biometriaColetada: false,
    criadoEm: '2023-01-01T00:00:00Z',
    criadoPor: 'Sistema',
    atualizadoEm: new Date().toISOString(),
    atualizadoPor: 'Sistema'
  }
};

export const PESSOA_DETALHE_MOCK: PessoaDetalhe = PESSOA_DETALHES_MOCK_MAP['1'];
